import styled from 'styled-components';

const AwardsContSkeletonStyle = styled.section`
	--homeAwardsBlockWidth: 80%;
	--homeAwardItemWidth: calc(50% - var(--sp12x));
	--homeAwardItemMarg: 0 var(--sp6x) var(--sp12x) var(--sp6x);

	svg {
		width: 100%;
		height: auto;
	}

	.home-awards-block {
		display: flex;
		flex-flow: wrap;
		max-width: var(--homeAwardsBlockWidth);
		margin: 0 auto;
	}

	.home-award-item-block {
		max-width: var(--homeAwardItemWidth);
		flex: 0 0 50%;
		margin: var(--homeAwardItemMarg);

		&:last-child,
		&:nth-last-child(2) {
			margin-bottom: 0;
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) {
		--homeAwardsBlockWidth: 86.3%;
		--homeAwardItemWidth: calc(50% - var(--sp8x));
		--homeAwardItemMarg: 0 var(--sp4x) var(--sp8x) var(--sp4x);
	}

	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) {
		--homeAwardItemWidth: calc(50% - var(--sp4x));
		--homeAwardItemMarg: 0 var(--sp2x) var(--sp5x) var(--sp2x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) {
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--homeAwardsBlockWidth: unset;
		--homeAwardItemWidth: calc(50% - var(--sp4x));
		--homeAwardItemMarg: 0 var(--sp2x) var(--sp5x) var(--sp2x);

		.home-awards-block {
			margin-left: calc(var(--sp2x) * -1);
			margin-right: calc(var(--sp2x) * -1);
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--homeAwardsBlockWidth: unset;
		--homeAwardItemWidth: 100%;
		--homeAwardItemMarg: unset;

		.home-awards-block {
			margin-left: unset;
			margin-right: unset;
		}

		.home-award-item-block {
			flex: unset;

			&:not(:last-child) {
				margin-bottom: var(--sp5x);
			}
		}
	}
`;

export default AwardsContSkeletonStyle;
